<template>
  <div>
    <h3 class="text-center">填写咨询方案前置问卷（2/3）</h3>
    <el-card class="box-card">
      <p>
        本页有助于咨询师详细了解你的教育/培训、工作经历和对未来职业生涯的期待，这部分信息可能是咨询过程中的重要切人点，请认真填写哦。</p>
      <br>
      <el-form :model="preQuizPart2" ref="formStep2" :rules="ruleStep2" label-position="top">
        <el-form-item label="4、教育与培训经历（请列出你所有获得过的学位、证书、执照或接受过的培训）" prop="educations">
          <p style="color:#909399;font-size:12px;line-height:17px;margin-bottom:12px;">
            教育经历中小学不用写，你认为自己所接受的培训对未来发展很重要、但没有相关证书，也可以写上。</p>
          <el-table :data="preQuizPart2.educations">
            <el-table-column prop="university" label="学校/培训机构" width="140"></el-table-column>
            <el-table-column prop="degree" label="学位/证书" width="100"></el-table-column>
            <el-table-column prop="year" label="年份" width="60"></el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <i class="el-icon-remove" style="color:#FE8087; margin:0 3px 0 6px;font-size:16px;"
                   @click="removeEducation(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button plain style="width:100%;margin-top:10px" @click="addEducationUI"><i
            class="el-icon-circle-plus"></i> 增加
          </el-button>
        </el-form-item>
        <el-form-item label="5、工作经验（兼职、义工等都算做工作经验）" prop="experiences">
          <el-table :data="preQuizPart2.experiences">
            <el-table-column prop="position" label="职位" width="60"></el-table-column>
            <el-table-column prop="org" label="工作单位/组织" width="70"></el-table-column>
            <el-table-column prop="jobType" label="工作性质" width="60"></el-table-column>
            <el-table-column prop="period" label="工作起止时间" width="60"></el-table-column>
            <el-table-column prop="salary" label="工资" width="50"></el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <i class="el-icon-remove" style="color:#FE8087; margin:0 3px 0 6px;font-size:16px;"
                   @click="removeExperience(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button plain style="width:100%;margin-top:10px" @click="addExperienceUI"><i
            class="el-icon-circle-plus"></i> 增加
          </el-button>
        </el-form-item>
        <el-form-item label="6、列出五项在职业生涯上最害怕的事" prop="careerAfraids">
          <p>第一件</p>
          <el-input v-model="preQuizPart2.careerAfraids[0]"></el-input>
          <p>第二件</p>
          <el-input v-model="preQuizPart2.careerAfraids[1]"></el-input>
          <p>第三件</p>
          <el-input v-model="preQuizPart2.careerAfraids[2]"></el-input>
          <p>第四件</p>
          <el-input v-model="preQuizPart2.careerAfraids[3]"></el-input>
          <p>第五件</p>
          <el-input v-model="preQuizPart2.careerAfraids[4]"></el-input>
        </el-form-item>
        <el-form-item label="7、你最早的志愿或抱负是什么" prop="initialWish">
          <el-input type="textarea" :rows="2" v-model="preQuizPart2.initialWish"></el-input>
        </el-form-item>
        <el-form-item label="8、试着完成下列语句" prop="completeWords">
          <p>当我想到毕业找工作，我就觉得</p>
          <el-input v-model="preQuizPart2.completeWords[0]"></el-input>
          <p>当我想到未来的职业生涯，我就觉得</p>
          <el-input v-model="preQuizPart2.completeWords[1]"></el-input>
          <p>我真正想从未来工作中得到的是</p>
          <el-input v-model="preQuizPart2.completeWords[2]"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-button type="primary" round style="width:100%;" @click="next">下一页</el-button>
    <br>
    <br>
    <el-dialog
      title="添加教育与培训经历"
      :visible.sync="addEducationVisible"
      width="100%"
      :show-close="false"
    >
      <el-form :model="formEducation" :rules="ruleEducation" ref="formEducation">
        <el-form-item prop="university">
          <el-input v-model="formEducation.university" placeholder="请输入学校/培训机构" clearable></el-input>
        </el-form-item>
        <el-form-item prop="degree">
          <el-input v-model="formEducation.degree" placeholder="请输入学位/证书" clearable></el-input>
        </el-form-item>
        <el-form-item prop="year">
          <el-select v-model="formEducation.year" placeholder="请选择获得学位/证书年份">
            <el-option label="2003" value="2003"></el-option>
            <el-option label="2004" value="2004"></el-option>
            <el-option label="2005" value="2005"></el-option>
            <el-option label="2006" value="2006"></el-option>
            <el-option label="2007" value="2007"></el-option>
            <el-option label="2008" value="2008"></el-option>
            <el-option label="2009" value="2009"></el-option>
            <el-option label="2010" value="2010"></el-option>
            <el-option label="2011" value="2011"></el-option>
            <el-option label="2012" value="2012"></el-option>
            <el-option label="2013" value="2013"></el-option>
            <el-option label="2014" value="2014"></el-option>
            <el-option label="2015" value="2015"></el-option>
            <el-option label="2016" value="2016"></el-option>
            <el-option label="2017" value="2017"></el-option>
            <el-option label="2018" value="2018"></el-option>
            <el-option label="2019" value="2019"></el-option>
            <el-option label="2020" value="2020"></el-option>
            <el-option label="2021" value="2021"></el-option>
            <el-option label="2022" value="2022"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddEducation">取 消</el-button>
        <el-button type="primary" @click="saveAddEducation">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加工作经验"
      :visible.sync="addExperienceVisible"
      width="100%"
      :show-close="false"
    >
      <el-form :model="formExperience" :rules="ruleExperience" ref="formExperience">
        <el-form-item prop="position">
          <el-input v-model="formExperience.position" placeholder="请输入工作职位" clearable></el-input>
        </el-form-item>
        <el-form-item prop="org">
          <el-input v-model="formExperience.org" placeholder="请输入工作单位/组织" clearable></el-input>
        </el-form-item>
        <el-form-item prop="jobType">
          <el-select v-model="formExperience.jobType" placeholder="请选择工作性质">
            <el-option label="全职" value="全职"></el-option>
            <el-option label="兼职" value="兼职"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="period">
          <el-input v-model="formExperience.period" placeholder="请输入工作起止时间" clearable></el-input>
        </el-form-item>
        <el-form-item prop="salary">
          <el-input v-model="formExperience.salary" placeholder="请输入工资" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddExperience">取 消</el-button>
        <el-button type="primary" @click="saveAddExperience">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";

export default {
  name: "fillin2",
  data() {
    return {
      addEducationVisible: false,
      addExperienceVisible: false,
      preQuizPart2: {
        educations: [],
        experiences: [],
        careerAfraids: [],
        initialWish: '',
        completeWords: [],
      },
      formEducation: {
        university: "",
        degree: "",
        year: "",
      },
      formExperience: {
        position: "",
        org: "",
        jobType: "",
        period: "",
        salary: "",
      },
      ruleStep2: {
        careerAfraids: [
          {required: true, message: '请输入', trigger: 'blur'},
        ],
        initialWish: [
          {required: true, message: '请输入', trigger: 'blur'},
        ],
        completeWords: [
          {required: true, message: '请输入', trigger: 'blur'},
        ],
      },
      ruleEducation: {
        university: [
          {required: true, message: "请输入学校/培训机构", trigger: "blur"},
        ],
        degree: [
          {required: true, message: "请输入学位/证书", trigger: "blur"},
        ],
        year: [
          {required: true, message: '请选择年份', trigger: 'change'},
        ]
      },
      ruleExperience: {
        position: [
          {required: true, message: "请输入工作职位", trigger: "blur"},
        ],
        org: [
          {required: true, message: "请输入工作单位/组织", trigger: "blur"},
        ],
        jobType: [
          {required: true, message: '请选择工作性质', trigger: 'change'},
        ],
        period: [
          {required: true, message: "请输入工作起止时间", trigger: "blur"},
        ],
      }
    };
  },
  mounted() {
  },
  methods: {
    addEducationUI() {
      this.addEducationVisible = true;
      this.formEducation = {year: '2022'};
    },
    cancelAddEducation() {
      this.addEducationVisible = false;
      this.$refs['formEducation'].clearValidate();
    },
    removeEducation(education) {
      this.preQuizPart2.educations = this.preQuizPart2.educations.filter((item) => {
        return item.university != education.university || item.degree != education.degree || item.year != education.year
      })
    },
    saveAddEducation() {
      this.$refs["formEducation"].validate((valid) => {
        if (valid) {
          this.preQuizPart2.educations.push({
            university: this.formEducation.university,
            degree: this.formEducation.degree,
            year: this.formEducation.year,
          });
          this.addEducationVisible = false;
        } else {
          return false;
        }
      });
    },
    addExperienceUI() {
      this.addExperienceVisible = true;

      this.formExperience = {jobType: '全职'};
    },
    cancelAddExperience() {
      this.addExperienceVisible = false;
      this.$refs['formExperience'].clearValidate();
    },
    removeExperience(experience) {
      this.preQuizPart2.experiences = this.preQuizPart2.experiences.filter((item) => {
        return item.position != experience.position || item.org != experience.org || item.jobType != experience.jobType || item.period != experience.period
      })
    },
    saveAddExperience() {
      this.$refs["formExperience"].validate((valid) => {
        if (valid) {
          this.preQuizPart2.experiences.push({
            position: this.formExperience.position,
            org: this.formExperience.org,
            jobType: this.formExperience.jobType,
            period: this.formExperience.period,
            salary: this.formExperience.salary,
          });
          this.addExperienceVisible = false;
        } else {
          return false;
        }
      });
    },
    next() {
      this.$refs["formStep2"].validate((valid) => {
        if (valid) {
          sessionStorage.setItem("preQuizPart2", JSON.stringify(this.preQuizPart2));
          this.$router.push('fillPreQuiz3');
        } else {
          return false;
        }
      });
    },
  }
};
</script>


<style scoped>
>>> .el-form-item__label {
  line-height: 20px;
}

>>> .el-checkbox__label {
  display: inline-grid;
  width: 300px;
  white-space: pre-line;
  word-wrap: break-word;
  line-height: 20px;
}

.el-table >>> th {
  font-weight: normal;
  color: #fff;
  background-color: #323a6b;
  /* text-align: center */
}

>>> .el-table th {
  padding: 0;
}

>>> .el-table .cell {
  font-size: 12px;
  line-height: 17px;
}
</style>
